import { render, staticRenderFns } from "./WebsiteCareOf.vue?vue&type=template&id=044e0aa2&scoped=true"
import script from "./WebsiteCareOf.vue?vue&type=script&lang=js"
export * from "./WebsiteCareOf.vue?vue&type=script&lang=js"
import style0 from "./WebsiteCareOf.vue?vue&type=style&index=0&id=044e0aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044e0aa2",
  null
  
)

export default component.exports